import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const DocumentHeader = () => {
    return (

        <Grid container spacing={0}>
            <Grid item xs={2}>
                <Typography variant="h6" gutterBottom>Дата</Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom>Вид</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom>Име</Typography>
            </Grid>
            <Grid item xs={1}>
                
            </Grid>
            <Grid item xs={2}>
                
            </Grid>

        </Grid>
    )
}

export default DocumentHeader;